"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchOps = exports.ThirdLevelRegionImpl = exports.UserAddressImpl = exports.RegionAddressImpl = exports.RegionHotCityImpl = exports.AssetsConfigImpl = void 0;
var AssetsConfigImpl = /** @class */ (function () {
    function AssetsConfigImpl(obj, version) {
        if (obj === void 0) { obj = []; }
        if (version === void 0) { version = '22001010'; }
        this.obj = [];
        this.version = '';
        this.obj = obj;
        this.version = version;
    }
    return AssetsConfigImpl;
}());
exports.AssetsConfigImpl = AssetsConfigImpl;
// 热门城市
var RegionHotCityImpl = /** @class */ (function () {
    function RegionHotCityImpl() {
    }
    return RegionHotCityImpl;
}());
exports.RegionHotCityImpl = RegionHotCityImpl;
// 行政区（省、市、区）
var RegionAddressImpl = /** @class */ (function () {
    function RegionAddressImpl() {
        this.areaCode = '';
        this.city = [];
        this.county = [];
        this.fullName = '';
        this.level = '';
        this.locationCode = '';
    }
    return RegionAddressImpl;
}());
exports.RegionAddressImpl = RegionAddressImpl;
// 用户行政地址
var UserAddressImpl = /** @class */ (function () {
    function UserAddressImpl(locationCode, provinceCode, province, cityCode, city, countyCode, county) {
        if (locationCode === void 0) { locationCode = ''; }
        if (provinceCode === void 0) { provinceCode = ''; }
        if (province === void 0) { province = ''; }
        if (cityCode === void 0) { cityCode = ''; }
        if (city === void 0) { city = ''; }
        if (countyCode === void 0) { countyCode = ''; }
        if (county === void 0) { county = ''; }
        this.locationCode = '';
        this.provinceCode = '';
        this.province = '';
        this.cityCode = '';
        this.city = '';
        this.countyCode = '';
        this.county = '';
        this.locationCode = locationCode;
        this.provinceCode = provinceCode;
        this.province = province;
        this.cityCode = cityCode;
        this.city = city;
        this.countyCode = countyCode;
        this.county = county;
    }
    return UserAddressImpl;
}());
exports.UserAddressImpl = UserAddressImpl;
// 三级行政区规则
var ThirdLevelRegionImpl = /** @class */ (function () {
    function ThirdLevelRegionImpl(province, city, county) {
        if (province === void 0) { province = [new UserAddressImpl()]; }
        if (city === void 0) { city = [new UserAddressImpl()]; }
        if (county === void 0) { county = [new UserAddressImpl()]; }
        this.city = [new UserAddressImpl()];
        this.county = [new UserAddressImpl()];
        this.province = [new UserAddressImpl()];
        this.province = province;
        this.city = city;
        this.county = county;
    }
    return ThirdLevelRegionImpl;
}());
exports.ThirdLevelRegionImpl = ThirdLevelRegionImpl;
var SearchOps = /** @class */ (function () {
    function SearchOps() {
        this.connector = '-';
        this.count = 10;
        this.regionKey = 'local_region_chn_sc';
        this.version = '';
    }
    return SearchOps;
}());
exports.SearchOps = SearchOps;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-region/dist/assets/class.js
// module id = xx0A
// module chunks = 1